export default __webpack_public_path__ + "static/media/icon_template.c6bf3f82.svg";